import { render, staticRenderFns } from "./AdminMonitoringStock.vue?vue&type=template&id=09752246&scoped=true&"
import script from "./AdminMonitoringStock.vue?vue&type=script&lang=js&"
export * from "./AdminMonitoringStock.vue?vue&type=script&lang=js&"
import style0 from "./AdminMonitoringStock.vue?vue&type=style&index=0&id=09752246&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09752246",
  null
  
)

export default component.exports